EXCLUDE_KEYS_LOCAL_STORAGE